var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3047_2400)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    width: 13,
    height: 31,
    rx: 4,
    transform: "rotate(90 50 0)",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 19,
    width: 13,
    height: 31,
    rx: 4,
    transform: "rotate(90 50 19)",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 32,
    width: 13,
    height: 32,
    rx: 4,
    transform: "rotate(-180 13 32)",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 37,
    width: 13,
    height: 50,
    rx: 4,
    transform: "rotate(90 50 37)",
    fill: "#495057"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3047_2400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.b0eb60a60f33c2445f6d93334df6f0b9.svg";
export { ForwardRef as ReactComponent };